import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_PATH}/administracao`

export default {
    obterTodas() {
        return axiosJwt
            .get(`${api}/controleacesso/aplicacoes`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterRegrasAcesso() {
        return axiosJwt
            .get(`${api}/controleacesso/aplicacoes/regrasacesso`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterPorId(id) {
        return axiosJwt
            .get(`${api}/controleacesso/aplicacoes/${id}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserir(aplicacao) {
        return axiosJwt
            .post(`${api}/controleacesso/aplicacoes`, aplicacao)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    atualizar(aplicacao) {
        return axiosJwt
            .put(`${api}/controleacesso/aplicacoes`, aplicacao)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    ativarDesativar(aplicacao, acao) {
        return axiosJwt
            .patch(
                `${api}/controleacesso/aplicacoes/${aplicacao.aplicacaoId}/${acao}`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    recriarToken(aplicacao) {
        return axiosJwt
            .patch(
                `${api}/controleacesso/aplicacoes/${aplicacao.aplicacaoId}/recriartoken`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    }
}
